import {brandsUtils} from "./brands-api.util";

const brandProps = brandsUtils.brandsProps

export const brandsAvailable = brandsByApi => {
    return brandsByApi.map(brand => {
        return brandProps[brand.name].config.type
    })
}
